export const SKU_TYPES = ['incremental', 'random']
export const SKU_FORMATS = ['numeric', 'alpha-numeric']

export const DATA_FIELDS_TITLE = [
  'category', 'type', 'brand', 'set', 'card', 'name', 'subset', 'variation',
  'attribute', 'team', 'grade', 'grader', 'numerical', 'condition', 'sku', 'cert', 'sn', 'note', 'rookie', 'auto',
  'cabinet', 'shelf', 'box', 'row', 'section'
]

export const DATA_FIELDS_DESCRIPTION = [
  'category', 'type', 'year', 'brand', 'set', 'card', 'name', 'subset', 'variation',
  'attribute', 'team', 'grade', 'grader', 'numerical', 'condition', 'sku', 'cert', 'sn', 'note', 'rookie', 'auto',
  'cabinet', 'shelf', 'box', 'row', 'section'
]

export const PLACEMENTS = ['top', 'bottom']

export const BUY_ADDONS_STEPS = ['Select Amount', 'Choose payment method']
export const CHANGE_PLAN_STEPS = ['Select Plan', 'Choose payment method']

export const NOTIFICATIONS = [
  {
    label: 'Privacy and legal updates',
    value: 'legal',
    description: 'Receive emails when we have important updates to share regarding our privacy policy or terms of service',
  },
  {
    label: 'CDP Changelog',
    value: 'changelog',
    description: 'CDP is constantly improving. Subscribe to the changelog to learn about new features and improvements.',
  },
  {
    label: 'CDP Newsletter',
    value: 'newsletter',
    description: 'CDP is constantly improving. Subscribe to the newsletter to learn about new features and improvements.',
  },
  {
    label: 'Daily Sale Recap',
    value: 'export',
    description: 'Receive a summary of the previous 24h sales activity, including items sold and inventory location.',
  },
  {
    label: 'Import Completion',
    value: 'import',
    description: 'Get an email when your inventory import has finished processing.',
  },
  {
    label: 'Publishing Completion',
    value: 'sales',
    description: 'Get notified when your selected listings have finished publishing to connected marketplaces.',
  },
]